import { Injectable, inject } from '@angular/core';

import { HttpClientPort } from '../../core/http/http-client.port';
import { Language } from '../../domain/entities/language';
import { Zone } from '../../domain/entities/zone';
import { ZoneRepository } from '../../domain/repositories/zone.repository';
import { toApiLanguage } from '../http/api-language';
import { BOLDEST_ENDPOINTS } from '../http/boldest-endpoints';
import { unwrapCollection } from '../mappers/raw-json';
import { toZone } from '../mappers/zone.mapper';

@Injectable()
export class HttpZoneRepository extends ZoneRepository {
  private readonly http = inject(HttpClientPort);

  async findAll(language: Language): Promise<readonly Zone[]> {
    const payload = await this.http.get({
      path: BOLDEST_ENDPOINTS.zones,
      query: { lang: toApiLanguage(language) },
    });

    return unwrapCollection(payload, 'zones')
      .map(toZone)
      .filter((zone): zone is Zone => zone !== null);
  }
}
